import React from "react";
import { kblTeamLogo } from "../SonicBoomSchedule";

const ScheduleCalendar = ({ year, month, data }) => {
  const generateCalendar = (year, month) => {
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);
    const daysInMonth = lastDay.getDate();
    const startDay = firstDay.getDay(); // 0 (일)부터 6 (토)

    const weeks = [];
    let currentWeek = [];

    // 데이터 매핑: 날짜별 게임 데이터를 객체로 변환
    const gameDataMap = {};
    data.list.forEach((item) => {
      const date = item.gameDate;
      gameDataMap[date] = item;
    });

    // 이전 달의 날짜 채우기 (필요 시)
    for (let i = 0; i < startDay; i++) {
      currentWeek.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      currentWeek.push(day);
      if ((startDay + day) % 7 === 0) {
        weeks.push(currentWeek);
        currentWeek = [];
      }
    }

    // 마지막 주가 채워지지 않았을 경우 남은 칸 채우기
    if (currentWeek.length > 0) {
      while (currentWeek.length < 7) {
        currentWeek.push(null);
      }
      weeks.push(currentWeek);
    }

    return weeks;
  };

  const weeks = generateCalendar(year, month);

  // 날짜 형식 맞추기
  const formatDate = (year, month, day) => {
    const mm = month < 10 ? `0${month}` : `${month}`;
    const dd = day < 10 ? `0${day}` : `${day}`;
    return `${year}${mm}${dd}`;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%", paddingBottom: "40px" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {["일", "월", "화", "수", "목", "금", "토"].map((day, idx) => (
          <div
            key={idx}
            style={{
              flex: 1,
              textAlign: "center",
              fontSize: "13px",
              borderTop: "1px solid #35383e",
              padding: "10px 0px",
              color: idx === 0 ? "#ea0101" : "#35383e",
            }}
          >
            {day}
          </div>
        ))}
      </div>
      {weeks.map((week, index) => (
        <div key={index} style={{ display: "flex", flexDirection: "row", backgroundColor: "white" }}>
          {week.map((day, idx) => {
            if (day === null) {
              return (
                <div
                  key={idx}
                  style={{
                    flex: 1,
                    height: "90px",
                    textAlign: "center",
                    border: "1px solid #ddd",
                    boxSizing: "border-box",
                    padding: "4px 6px",
                  }}
                >
                  {/* 빈 날짜 */}
                </div>
              );
            }

            const currentDate = formatDate(year, month, day);
            const game = data.list.find((item) => item.gameDate === currentDate);
            let oppTeam = "";
            let victory = "";

            if (game) {
              oppTeam = game.logoH === "kt" ? game.logoA : game.logoH;
            }

            if (game) {
              if (game.isStarted === 0) {
                victory = "not";
              } else if (game.logoH === "kt") {
                game.scoreH > game.scoreA ? (victory = "win") : (victory = "lose");
              } else if (game.logoA === "kt") {
                game.scoreH < game.scoreA ? (victory = "win") : (victory = "lose");
              } else {
                victory = "draw";
              }
            }

            return (
              <div
                key={idx}
                style={{
                  flex: 1,
                  height: "90px",
                  textAlign: "left",
                  border: "1px solid #ddd",
                  boxSizing: "border-box",
                  position: "relative",
                  padding: "4px 6px",
                }}
              >
                {day}
                {game && (
                  <div style={{ padding: "0px 0px", fontSize: "10px", height: "54px" }}>
                    <img
                      src={kblTeamLogo[oppTeam]}
                      alt={oppTeam}
                      style={{ width: "30px", height: "32px", margin: "4px 0px" }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      {game.logoH === "kt" ? (
                        <div style={{ color: "#d60c0c", fontSize: "12px", fontWeight: "bold" }}>H</div>
                      ) : (
                        <div style={{ color: "#717781", fontSize: "12px", fontWeight: "bold" }}>A</div>
                      )}
                      {victory === "not" ? (
                        <div> </div>
                      ) : victory === "win" ? (
                        <div
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#d60c0c",
                            borderRadius: "4px",
                            padding: "2px",
                            fontSize: "10px",
                          }}
                        >
                          승
                        </div>
                      ) : (
                        <div
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#000000",
                            borderRadius: "4px",
                            padding: "2px",
                            fontSize: "10px",
                          }}
                        >
                          패
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ScheduleCalendar;
